import { BrowserProvider } from 'ethers';
import { useEffect, useMemo, useRef, useState } from 'react';
export const createProviderHooks = (wallet) => {
    const { useAccount, useChainId, getConnector } = wallet;
    const useProvider = (network) => {
        const account = useAccount();
        const chainId = useChainId();
        return useMemo(() => {
            // to ensure connectors remain fresh, we condition re-renders
            // when ImportedWeb3Provider account, chainId changed
            void account && chainId;
            const provider = getConnector().provider;
            if (provider) {
                return new BrowserProvider(provider, network);
            }
            return undefined;
        }, [account, chainId, network]);
    };
    const useHasProvider = (...args) => {
        const [hasProvider, setHasProvider] = useState(false);
        const argsRef = useRef(args);
        argsRef.current = args;
        useEffect(() => {
            let canceled = false;
            getConnector()
                .detectProvider(...argsRef.current)
                .then(() => {
                if (!canceled)
                    setHasProvider(true);
            })
                .catch(() => {
                if (!canceled)
                    setHasProvider(false);
            });
            return () => {
                canceled = true;
            };
        }, []);
        return hasProvider;
    };
    return {
        useProvider,
        useHasProvider,
    };
};
